"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _axios = _interopRequireDefault(require("axios"));

var _interfaces = require("@insided/deprecated-control/EmailCampaigns/interfaces");

var _KeyInsightCard = require("@insided/deprecated-control/analytics/KeyInsightCard");

var _EmptyPage = _interopRequireDefault(require("@insided/deprecated-preact-components/empty-page/EmptyPage"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _Columns = require("../../UserOverview/Columns");

var _Index = _interopRequireDefault(require("@insided/deprecated-control/UserOverview/Index"));

var _Loader = _interopRequireDefault(require("../../ui-components/Loader"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_PAGE = 1;
var DEFAULT_PAGE_SIZE = 25;
var DEFAULT_PAGE_SIZES = [10, 25, 50, 100];
var OVERVIEW_TYPE = 'UserOverviewByMetrics';
var STORAGE_KEY = "".concat(OVERVIEW_TYPE, "-filter-criteria");

function getRate(count, totalCount) {
  if (!totalCount) return '-';
  return count / totalCount * 100;
}

var MetricsPanel = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(MetricsPanel, _Component);

  var _super = _createSuper(MetricsPanel);

  function MetricsPanel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, MetricsPanel);
    _this = _super.call(this, props);
    _this.state = {
      activeMetric: null,
      usersIds: null,
      totalUsers: 0,
      isLoading: false
    };
    _this.setActiveMetric = _this.setActiveMetric.bind((0, _assertThisInitialized2.default)(_this));
    _this.fetchUsersIds = _this.fetchUsersIds.bind((0, _assertThisInitialized2.default)(_this));
    _this.setSessionStorage = _this.setSessionStorage.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(MetricsPanel, [{
    key: "setSessionStorage",
    value: function setSessionStorage(key, value) {
      var storage = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY));
      storage[key] = value;
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(storage));
    }
  }, {
    key: "setActiveMetric",
    value: function () {
      var _setActiveMetric = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(newActiveMetric) {
        var _this2 = this;

        var activeMetric, pagination;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                activeMetric = this.state.activeMetric;
                pagination = {
                  page: DEFAULT_PAGE,
                  pageSize: DEFAULT_PAGE_SIZE,
                  pageSizes: DEFAULT_PAGE_SIZES
                };

                if (newActiveMetric !== activeMetric) {
                  this.setState({
                    activeMetric: newActiveMetric,
                    usersIds: null
                  }, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
                    return _regenerator.default.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!window.sessionStorage.getItem(STORAGE_KEY)) {
                              window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
                                pagination: pagination
                              }));
                            } else {
                              _this2.setSessionStorage('pagination', pagination);
                            }

                            _context.next = 3;
                            return _this2.fetchUsersIds({
                              page: DEFAULT_PAGE,
                              pageSize: DEFAULT_PAGE_SIZE
                            });

                          case 3:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  })));
                } else {
                  this.setState({
                    activeMetric: null,
                    usersIds: null
                  });
                }

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setActiveMetric(_x) {
        return _setActiveMetric.apply(this, arguments);
      }

      return setActiveMetric;
    }()
  }, {
    key: "fetchUsersIds",
    value: function () {
      var _fetchUsersIds = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(_ref2) {
        var _this3 = this;

        var page, pageSize, callback, campaignId, activeMetric, res, usersIds;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                page = _ref2.page, pageSize = _ref2.pageSize, callback = _ref2.callback;
                this.setState({
                  isLoading: true
                });
                campaignId = this.props.campaignId;
                activeMetric = this.state.activeMetric;
                _context3.prev = 4;
                _context3.next = 7;
                return _axios.default.get("/email/email-campaign/".concat(campaignId, "/metrics?metric_type=").concat(activeMetric, "&page=").concat(page, "&page_size=").concat(pageSize));

              case 7:
                res = _context3.sent;
                usersIds = res === null || res === void 0 ? void 0 : res.data.metrics.map(function (user) {
                  return user.user_id;
                });
                this.setState({
                  usersIds: usersIds,
                  totalUsers: res === null || res === void 0 ? void 0 : res.data.total_items,
                  isLoading: false
                }, function () {
                  _this3.setSessionStorage('filters', {
                    usersIds: usersIds
                  });

                  if (callback) {
                    callback();
                  }
                });
                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](4);
                this.setState({
                  usersIds: [],
                  totalUsers: 0,
                  isLoading: false
                }, function () {
                  _this3.setSessionStorage('filters', {
                    usersIds: []
                  });

                  if (callback) {
                    callback();
                  }
                });

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 12]]);
      }));

      function fetchUsersIds(_x2) {
        return _fetchUsersIds.apply(this, arguments);
      }

      return fetchUsersIds;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          metrics = _this$props.metrics,
          roles = _this$props.roles,
          groups = _this$props.groups;
      var _this$state = this.state,
          activeMetric = _this$state.activeMetric,
          usersIds = _this$state.usersIds,
          totalUsers = _this$state.totalUsers,
          isLoading = _this$state.isLoading;
      var emptyPageImageUrl = "".concat((0, _globals.default)('basePath'), "images/empty_result.png");
      return (0, _preact.h)("div", {
        className: "metric-container-wrapper"
      }, isLoading && (0, _preact.h)(_Loader.default, null), (0, _preact.h)("div", {
        className: "metric-container"
      }, (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "No. of emails sent",
        total: metrics.sent_count,
        hideComparisionWithPreviousPeriod: true,
        isLoading: false,
        metricsType: _interfaces.MetricsTypes.sent,
        onCardClick: this.setActiveMetric,
        isActive: activeMetric === _interfaces.MetricsTypes.sent
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Delivery rate",
        total: getRate(metrics.delivered_count, metrics.sent_count),
        metricInitialCount: metrics.delivered_count,
        showInitialCount: true,
        titleTooltip: "The delivery rate is the percentage of emails delivered into your recipients inboxes that were not blocked, bounced or rejected.",
        hideComparisionWithPreviousPeriod: true,
        isPercentage: true,
        isLoading: false,
        metricsType: _interfaces.MetricsTypes.delivered,
        onCardClick: this.setActiveMetric,
        isActive: activeMetric === _interfaces.MetricsTypes.delivered
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Open rate",
        total: getRate(metrics.opened_count, metrics.sent_count),
        metricInitialCount: metrics.opened_count,
        showInitialCount: true,
        titleTooltip: "Open rate is the percentage of recipients that opened the email.",
        hideComparisionWithPreviousPeriod: true,
        isPercentage: true,
        isLoading: false,
        metricsType: _interfaces.MetricsTypes.opened,
        onCardClick: this.setActiveMetric,
        isActive: activeMetric === _interfaces.MetricsTypes.opened
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Click-through rate",
        total: getRate(metrics.clicked_count, metrics.sent_count),
        metricInitialCount: metrics.clicked_count,
        showInitialCount: true,
        titleTooltip: "Click-through rate is the percentage of the no. of unique recipients who clicked any link in the messages.",
        hideComparisionWithPreviousPeriod: true,
        isPercentage: true,
        isLoading: false,
        metricsType: _interfaces.MetricsTypes.clicked,
        onCardClick: this.setActiveMetric,
        isActive: activeMetric === _interfaces.MetricsTypes.clicked
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Spam rate",
        total: getRate(metrics.spam_count, metrics.sent_count),
        metricInitialCount: metrics.spam_count,
        showInitialCount: true,
        titleTooltip: "Spam rate is the percentage of recipients that marked the email as spam.",
        hideComparisionWithPreviousPeriod: true,
        isPercentage: true,
        isLoading: false,
        metricsType: _interfaces.MetricsTypes.complaint,
        onCardClick: this.setActiveMetric,
        isActive: activeMetric === _interfaces.MetricsTypes.complaint
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Unsubscribe rate",
        total: getRate(metrics.unsubscribed_count, metrics.sent_count),
        metricInitialCount: metrics.unsubscribed_count,
        showInitialCount: true,
        titleTooltip: "Unsubscribe rate is the number of times a recipient clicked unsubscribe links in the messages.",
        hideComparisionWithPreviousPeriod: true,
        isPercentage: true,
        isLoading: false,
        metricsType: _interfaces.MetricsTypes.unsubscribed,
        onCardClick: this.setActiveMetric,
        isActive: activeMetric === _interfaces.MetricsTypes.unsubscribed
      })), activeMetric && usersIds ? (0, _preact.h)("div", null, usersIds.length ? (0, _preact.h)(_Index.default, {
        customProfileFields: [],
        badges: [],
        ranks: [],
        groups: groups,
        flashMessages: {},
        roles: roles,
        onDataFetched: function onDataFetched() {},
        withHeader: false,
        showFilters: false,
        withActionElements: false,
        withMultiSelect: false,
        totalUsers: totalUsers,
        onPaginationAction: this.fetchUsersIds,
        type: "UserOverviewByMetrics",
        model: (0, _Columns.getUsersByMetricsColumns)(roles, groups),
        defaultFilters: {
          usersIds: usersIds
        }
      }) : (0, _preact.h)("div", null, (0, _preact.h)(_EmptyPage.default, {
        img_src: emptyPageImageUrl,
        header: "No results found",
        text: 'Sorry, that filter combination has no results.\n Please try different criteria.'
      }))) : null);
    }
  }]);
  return MetricsPanel;
}(_preact.Component);

var _default = MetricsPanel;
exports.default = _default;